import { BoardDiscussion, FinancialMonthMetric } from '../types';

export const INITIAL_BOARD_DISCUSSIONS: BoardDiscussion[] = [
  {
    id: 'board-1',
    title: 'โครงการติดตั้งกล้อง CCTV ความละเอียดสูง 4K เพิ่มเติม 8 จุด บริเวณแนวรั้วรอบโครงการและทางแยกซอย',
    category: 'security_rule',
    budget_amount: 48500,
    created_by: 'คุณอนุกูล พรหมดี',
    author_role: 'กรรมการฝ่ายความปลอดภัยและเทคโนโลยี (บ้าน 88/12)',
    created_at: new Date(Date.now() - 3600000 * 24 * 4).toISOString(),
    deadline: '2026-08-25',
    status: 'active_voting',
    description:
      'เนื่องจากได้รับแจ้งจากลูกบ้านซอย 6-8 ว่ามีจุดอับสายตาบริเวณแนวรั้วโครงการด้านหลัง จึงขอเสนอจัดซื้อกล้องวงจรปิดระบบ AI สแกนป้ายทะเบียนและตรวจจับการบุกรุกข้ามแนวรั้วจำนวน 8 ตัว พร้อมฮาร์ดดิสก์ NVR 8TB จากกองทุนความปลอดภัยโครงการ',
    votes: [
      {
        voter_id: 'board-01',
        voter_name: 'คุณอนุกูล พรหมดี',
        voter_role: 'กรรมการความปลอดภัย',
        vote: 'approve',
        voted_at: new Date(Date.now() - 3600000 * 24 * 3).toISOString(),
        comment: 'เสนอขออนุมัติเพื่อยกระดับความปลอดภัยให้ลูกบ้านทุกหลังคาเรือนครับ',
      },
      {
        voter_id: 'board-02',
        voter_name: 'คุณกิตติศักดิ์ บุญเรือง',
        voter_role: 'ประธานกรรมการหมู่บ้าน',
        vote: 'approve',
        voted_at: new Date(Date.now() - 3600000 * 24 * 2).toISOString(),
        comment: 'เห็นชอบครับ ยอดงบประมาณไม่เกินเพดานอำนาจอนุมัติของกรรมการ และเป็นประโยชน์โดยตรง',
      },
      {
        voter_id: 'board-03',
        voter_name: 'คุณชลธิชา เจริญชัย',
        voter_role: 'กรรมการฝ่ายบัญชีและการเงิน',
        vote: 'approve',
        voted_at: new Date(Date.now() - 3600000 * 24 * 1).toISOString(),
        comment: 'ตรวจสอบงบประมาณสำรองแล้ว มีสภาพคล่องเพียงพอ ไม่กระทบค่าใช้จ่ายประจำเดือน',
      },
    ],
    comments: [
      {
        id: 'comm-1',
        author_name: 'คุณกิตติศักดิ์ บุญเรือง',
        author_role: 'ประธานกรรมการ',
        content: 'รบกวนฝ่ายช่างเปรียบเทียบใบเสนอราคาอย่างน้อย 2 เจ้า เพื่อความโปร่งใสก่อนเบิกจ่ายงบ',
        created_at: new Date(Date.now() - 3600000 * 24 * 2).toISOString(),
      },
      {
        id: 'comm-2',
        author_name: 'คุณอนุกูล พรหมดี',
        author_role: 'กรรมการความปลอดภัย',
        content: 'ได้จัดทำตารางเปรียบเทียบสเปกจาก บ.ซีเคียวริตี้เทค และ บ.สมาร์ทการ์ด เรียบร้อยแล้วครับ',
        created_at: new Date(Date.now() - 3600000 * 24 * 1.5).toISOString(),
      },
    ],
  },
  {
    id: 'board-2',
    title: 'การจัดซื้อปั๊มน้ำสำรองและสารกรองทรายสำหรับระบบสระว่ายน้ำสโมสร (Infinity Pool Filter Renewal)',
    category: 'maintenance_project',
    budget_amount: 32000,
    created_by: 'คุณศศิธร เจริญสุข',
    author_role: 'ผู้จัดการนิติบุคคล',
    created_at: new Date(Date.now() - 3600000 * 24 * 8).toISOString(),
    deadline: '2026-08-18',
    status: 'passed',
    description:
      'เนื่องจากปั๊มกรองสระว่ายน้ำตัวเก่าใช้งานมานานกว่า 3 ปี เริ่มมีเสียงดังและแรงดันตก จึงขออนุมัติเปลี่ยนสารกรองแก้ว (Glass Media) และติดตั้งปั๊มเสริม 2HP',
    votes: [
      {
        voter_id: 'board-01',
        voter_name: 'คุณกิตติศักดิ์ บุญเรือง',
        voter_role: 'ประธานกรรมการ',
        vote: 'approve',
        voted_at: '2026-08-10T10:00:00Z',
      },
      {
        voter_id: 'board-02',
        voter_name: 'คุณชลธิชา เจริญชัย',
        voter_role: 'กรรมการการเงิน',
        vote: 'approve',
        voted_at: '2026-08-10T11:15:00Z',
      },
      {
        voter_id: 'board-03',
        voter_name: 'คุณอนุกูล พรหมดี',
        voter_role: 'กรรมการความปลอดภัย',
        vote: 'approve',
        voted_at: '2026-08-10T14:30:00Z',
      },
      {
        voter_id: 'board-04',
        voter_name: 'พญ. พรพิมล กาญจนกิจ',
        voter_role: 'กรรมการฝ่ายสิ่งแวดล้อมและสุขอนามัย',
        vote: 'approve',
        voted_at: '2026-08-11T08:20:00Z',
      },
    ],
    comments: [
      {
        id: 'comm-3',
        author_name: 'พญ. พรพิมล กาญจนกิจ',
        author_role: 'กรรมการสุขอนามัย',
        content: 'เห็นด้วยอย่างยิ่งค่ะ คุณภาพน้ำสระว่ายน้ำส่งผลต่อสุขภาพลูกบ้านและเด็กๆ',
        created_at: '2026-08-11T08:22:00Z',
      },
    ],
    resolution_summary: 'มติที่ประชุมกรรมการ: อนุมัติงบประมาณ 32,000 บาท ด้วยมติเอกฉันท์ 4/4 เสียง มอบหมายนิติดำเนินการจัดซื้อ',
  },
  {
    id: 'board-3',
    title: 'ข้อบังคับการจอดรถบนถนนเมนและซอยย่อย ห้ามจอดค้างคืนกีดขวางทางสัญจร',
    category: 'security_rule',
    created_by: 'คุณกิตติศักดิ์ บุญเรือง',
    author_role: 'ประธานกรรมการหมู่บ้าน',
    created_at: new Date(Date.now() - 3600000 * 24 * 12).toISOString(),
    deadline: '2026-08-30',
    status: 'in_discussion',
    description:
      'กำหนดมาตรการตักเตือนและล็อกล้อกรณีจอดรถกีดขวางทางกลับรถหรือจอดค้างคืนบนถนนเมนหลักเกิน 24 ชม. โดยไม่มีการแจ้งนิติบุคคล เพื่อความเป็นระเบียบเรียบร้อยและความปลอดภัยกรณีรถดับเพลิง/รถพยาบาลเข้าพื้นที่',
    votes: [
      {
        voter_id: 'board-01',
        voter_name: 'คุณกิตติศักดิ์ บุญเรือง',
        voter_role: 'ประธานกรรมการ',
        vote: 'approve',
        voted_at: '2026-08-05T09:00:00Z',
      },
      {
        voter_id: 'board-02',
        voter_name: 'คุณอนุกูล พรหมดี',
        voter_role: 'กรรมการความปลอดภัย',
        vote: 'approve',
        voted_at: '2026-08-05T10:30:00Z',
      },
    ],
    comments: [
      {
        id: 'comm-4',
        author_name: 'คุณอนุกูล พรหมดี',
        author_role: 'กรรมการความปลอดภัย',
        content: 'ควรมีขั้นตอนติดใบเตือนสีส้มก่อน 2 ครั้ง หากยังเพิกเฉยจึงเริ่มใช้มาตรการปรับตามระเบียบ',
        created_at: '2026-08-05T10:32:00Z',
      },
    ],
  },
];

export const INITIAL_FINANCIAL_METRICS: FinancialMonthMetric[] = [
  {
    month: '2026-03',
    month_label: 'มี.ค. 69',
    total_billed: 165000,
    total_collected: 156000,
    total_pending: 9000,
    operational_expense: 35000,
    security_expense: 58000,
    landscape_cleaning_expense: 28000,
    repairs_fund_expense: 14000,
    net_surplus: 21000,
    collection_rate_pct: 94.5,
  },
  {
    month: '2026-04',
    month_label: 'เม.ย. 69',
    total_billed: 165000,
    total_collected: 159500,
    total_pending: 5500,
    operational_expense: 36000,
    security_expense: 58000,
    landscape_cleaning_expense: 28000,
    repairs_fund_expense: 12500,
    net_surplus: 25000,
    collection_rate_pct: 96.7,
  },
  {
    month: '2026-05',
    month_label: 'พ.ค. 69',
    total_billed: 168000,
    total_collected: 162000,
    total_pending: 6000,
    operational_expense: 35500,
    security_expense: 58000,
    landscape_cleaning_expense: 28000,
    repairs_fund_expense: 18000,
    net_surplus: 22500,
    collection_rate_pct: 96.4,
  },
  {
    month: '2026-06',
    month_label: 'มิ.ย. 69',
    total_billed: 168000,
    total_collected: 164500,
    total_pending: 3500,
    operational_expense: 37000,
    security_expense: 58000,
    landscape_cleaning_expense: 29000,
    repairs_fund_expense: 11000,
    net_surplus: 29500,
    collection_rate_pct: 97.9,
  },
  {
    month: '2026-07',
    month_label: 'ก.ค. 69',
    total_billed: 168000,
    total_collected: 161000,
    total_pending: 7000,
    operational_expense: 36500,
    security_expense: 58000,
    landscape_cleaning_expense: 29000,
    repairs_fund_expense: 22000,
    net_surplus: 15500,
    collection_rate_pct: 95.8,
  },
  {
    month: '2026-08',
    month_label: 'ส.ค. 69 (ปัจจุบัน)',
    total_billed: 172500,
    total_collected: 148200,
    total_pending: 24300,
    operational_expense: 36000,
    security_expense: 58000,
    landscape_cleaning_expense: 29000,
    repairs_fund_expense: 8500,
    net_surplus: 16700,
    collection_rate_pct: 85.9,
  },
];
